import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, ButtonToolbar, Form, Modal, SelectPicker} from 'rsuite';
import {deleteUserSkill, updateUserSkill} from "../../../service/skillService";
import {skillModel} from "../../form/models";

const EditSkillModal = (props) => {
    const { open, handleClose, skill, skillExpLevels } = props;

    const [localState, setLocalState] = useState({});

    const submitSkillEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserSkill(localState).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    const submitSkillDelete = useCallback(() => {
        deleteUserSkill({id: localState.id, userId: localState.userId}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    useEffect(() => {
        setLocalState({...skill});
    }, [skill]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = useCallback((event) => setLocalState({...localState, ...event}),[localState]);

    return useMemo(() => {
        return (
            <Modal
                open={open}
                onClose={handleClose}
                backdrop="static"
            >
                <Modal.Header>
                    <Modal.Title>Edit Skill</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Only Experience Level and years is modifiable. Add/delete skills as needed otherwise.
                    </p>
                </Modal.Body>
                <Form layout="horizontal"
                      model={skillModel}
                      onChange={handleFormChange}
                      onSubmit={submitSkillEdit}
                      formDefaultValue={skill}>
                    <Form.Group>
                        <Form.ControlLabel>Skill Name</Form.ControlLabel>
                        <Form.Control name="skillName" disabled/>
                    </Form.Group>
                    <Form.Group>
                        <Form.ControlLabel>Skill Type</Form.ControlLabel>
                        <Form.Control name="skillType" disabled/>
                    </Form.Group>
                    <Form.Group>
                        <Form.ControlLabel>Skill Level</Form.ControlLabel>
                        <Form.Control name="skillExpLevel"
                                      accepter={SelectPicker}
                                      data={skillExpLevels}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.ControlLabel>Years Experience</Form.ControlLabel>
                        <Form.Control name="yearsExp"/>
                    </Form.Group>
                    <Form.Group>
                        <ButtonToolbar>
                            <Button type="submit" appearance="primary">
                                Ok
                            </Button>
                            <Button onClick={handleClose} appearance="default">
                                Cancel
                            </Button>
                            <Button onClick={submitSkillDelete} appearance="primary" color="red">
                                Delete Skill
                            </Button>
                        </ButtonToolbar>
                    </Form.Group>
                </Form>
            </Modal>
        );},
        [
            handleClose,
            handleFormChange,
            open,
            skill,
            skillExpLevels,
            submitSkillDelete,
            submitSkillEdit,
        ]
    );

}

export default EditSkillModal;